import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/es'
import 'dayjs/locale/en'
import 'dayjs/locale/de'
import 'dayjs/locale/ru'
import 'dayjs/locale/fr'

dayjs.extend(utc)
dayjs.extend(localizedFormat)

// Set locale based on browser
const browserLocale = navigator.language.toLowerCase()
dayjs.locale(browserLocale)

// use this if timestamp has both date and time
export const parseDateInAOHstandard = (date: string | Date): string => {
  return dayjs(date).utc().locale(browserLocale).format('ddd, DD MMM YYYY HH:mm:ss') + ' GMT'
}

export function convertDateIntoAohStandardInUTC (date: string | null | Date): string {
  if (date === null) return ''
  return dayjs.utc(date).locale(browserLocale).format('ddd, DD MMM YYYY') // Use utc to handle possible UTC string correctly
}

// use this if timestamp has only date
export function convertDateIntoAohStandardUsingDayjs (date: string | null | Date | undefined): string {
  if (date === null || date === undefined) return ''
  return dayjs(date).locale(browserLocale).format('ddd, DD MMM YYYY')
}

export function convertDateIntoAohStandardUnSeperated (date: string | null | Date): string {
  if (date === null) return ''
  return dayjs(date).locale(browserLocale).format('ddd DD MMM YYYY')
}
